import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import { Grid } from "@mui/material";
import Paper from "../../surfaces/paper/Paper";
import Typography from "../../data-display/typography/Typography";
// Limitless imports
import { useNavigation } from "@limitless/portal";
import { BoxRenderer } from "@limitless/portal";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import ArrowRight from "@limitless/icons/ArrowRight";
import TrendingUp from "@limitless/icons/TrendingUp";
import TrendingDown from "@limitless/icons/TrendingDown";
import HelpOutlineIcon from "@limitless/icons/HelpOutlineIcon";
const useStyles = makeStyles(theme => ({
  textLabel: {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  icon: {
    marginLeft: "5px"
  },
  typography: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    display: "flex",
    cursor: "pointer"
  }
}));
const Tile = ({
  label,
  value,
  rightLabel,
  subLabel,
  isButton = true,
  url,
  trendingRate,
  trendingStatus,
  tooltip
}) => {
  const classes = useStyles();
  const {
    navigate
  } = useNavigation();
  return /*#__PURE__*/React.createElement(Paper, {
    sx: {
      padding: "32px",
      backgroundColor: theme => theme.palette.background.elevation1,
      boxShadow: " 0px 2px 4px rgba(33, 36, 41, 0.05"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    className: classes.textLabel
  }, /*#__PURE__*/React.createElement(Typography, {
    color: theme => theme.palette.text.primary,
    variant: "body2"
  }, label), isButton ? /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.typography,
    onClick: () => navigate(url)
  }, rightLabel, /*#__PURE__*/React.createElement(ArrowRight, {
    fontSize: "small",
    style: {
      marginLeft: "10px"
    }
  })) : /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.text.secondary
    }
  }, rightLabel))), /*#__PURE__*/React.createElement(Grid, {
    sx: {
      marginTop: "18px"
    },
    className: classes.textLabel
  }, /*#__PURE__*/React.createElement(Grid, {
    sx: {
      display: "flex",
      flexDirection: "row"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    color: theme => theme.palette.text.primary,
    variant: "h3"
  }, value), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.text.secondary,
      display: "inline-block",
      margin: "auto auto 8px 14px"
    }
  }, subLabel, tooltip && subLabel && /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(HelpOutlineIcon, {
      fontSize: "medium",
      sx: {
        color: theme => theme.palette.text.secondary
      }
    }),
    label: tooltip
  }))), trendingRate && /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(BoxRenderer, {
    style: {
      borderRadius: "16px",
      margin: "auto",
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 8,
      paddingRight: 8
    },
    showRadius: true,
    value: "",
    variant: "contained",
    color: trendingStatus ? "secondary-light" : "error-cold"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    sx: {
      display: "flex",
      justifyContent: "center",
      padding: "6px",
      color: theme => theme.palette.secondary.contrastText
    },
    onClick: () => navigate(url)
  }, `${trendingRate}%`, trendingStatus ? /*#__PURE__*/React.createElement(TrendingUp, {
    fontSize: "small",
    className: classes.icon
  }) : /*#__PURE__*/React.createElement(TrendingDown, {
    fontSize: "small",
    className: classes.icon
  }))))));
};
Tile.propTypes = {
  label: PropTypes.string,
  rightLabel: PropTypes.string,
  url: PropTypes.string,
  subLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  trendingRate: PropTypes.any,
  trendingStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  tooltip: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isButton: PropTypes.bool
};
export default Tile;